import { render, staticRenderFns } from "./white_list_sys.vue?vue&type=template&id=e6cb2d08&scoped=true&"
import script from "./white_list_sys.vue?vue&type=script&lang=js&"
export * from "./white_list_sys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cb2d08",
  null
  
)

component.options.__file = "white_list_sys.vue"
export default component.exports